import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import * as types from './mutation-types'
// import * as mutations from 'mutations'

import app from './modules/app'
import menu from './modules/menu'
import schedule from './modules/schedule'
import auth from './modules/auth'
import medicalRecord from './modules/medical-record'
import patient from './modules/patient'
import proced from './modules/proced'
import exam from './modules/exam'
import examinationReport from './modules/examination-report'
import memed from './modules/memed'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  actions,
  getters,
  modules: {
    app,
    menu,
    schedule,
    auth,
    medicalRecord,
    patient,
    proced,
    exam,
    examinationReport,
    memed
  },
  state: {
    customer: '',
    recoveryPassword: {
      token: null
    }
  },
  mutations: {
    [types.CUSTOMER] (store, obj) {
      store.customer = obj
    },
    [types.RECOVERY_PASSWORD] (store, obj) {
      store.recoveryPassword.token = obj
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js